import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
  PMSmallNumberProps,
} from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { PROJECT_NAMES } from "vmd-types";

import { TestAppState } from "../../../app";
import { getPluralOfItemNameFromState } from "../../../utils/get-plural-of-item-name";

/**
 * Adds the number-of-items and number-of-projects small-number cards, in
 * that order (#2222).
 */
export function addItemAndProjectCountCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const numberOfItemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfItemsComponent",
      labels: ["#ofItems"],
      description: "",
      title: "",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfItemsComponent.mapLayoutProps(({ language }) => ({
    componentId: "numberOfItemsComponent",
    labels: ["#ofItems"],
    description:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.numberOfItemsDescription"
      ) || `Shows the number of Tracking Items.`,
    title:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.numberOfItemsTitle"
      ) || `Items`,
    editSchema: PMSmallNumberCardEditSchema,
  }));

  numberOfItemsComponent.mapState(
    ({ overview, reportComponentValues, ...appState }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        number: a?.number ?? overview?._calculated?.numberOfSubEntities ?? 0,
        description:
          getLocalizedMessage(
            appState.language || "en",
            "overviewPlugin.numberOfItemsDescription"
          ) || `Shows the number of Tracking Items.`,
        title: a?.title ?? `${getPluralOfItemNameFromState(appState)}`,
      };
    }
  );

  const numberOfProjectsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfProjectsComponent",
      labels: ["#ofProjects"],
      description: "",
      title: "",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfProjectsComponent.mapLayoutProps(({ language }) => ({
    componentId: "numberOfProjectsComponent",
    labels: ["#ofProjects"],
    description:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.numberOfProjectsDescription"
      ) || `Shows the number of Projects.`,
    title:
      getLocalizedMessage(
        language || "en",
        "overviewPlugin.numberOfProjectsTitle"
      ) || `Projects`,
    editSchema: PMSmallNumberCardEditSchema,
  }));

  numberOfProjectsComponent.mapState(
    ({ overview, reportComponentValues, settings, language }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfItemsComponent"
      ] as PMSmallNumberProps | undefined;
      const projectsCount = (overview?.projects ?? []).length;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title:
          a?.title ??
          `${
            PROJECT_NAMES.find(
              (name) => name.single === settings?.configuration?.projectName
            )?.plural ?? "Projects"
          }`,
        number: a?.number ?? projectsCount,
        description:
          getLocalizedMessage(
            language || "en",
            "overviewPlugin.numberOfProjectsDescription"
          ) || `Shows the number of Projects.`,
      };
    }
  );
}
